/**
 * @file Consumer Master Route Component.
 */

import { renderRoutes } from 'react-router-config';

import routes from './routes';
import RequireAuth from '../../../components/routing/RequireAuth';
import RequireRole from '../../../components/routing/RequireRole';
import ACCOUNT_ROLES from '../../../constants/account-roles';

const RequireConsumerRole = RequireRole([ACCOUNT_ROLES.CONSUMER]);

const ConsumerMasterRoute = RequireAuth(
  RequireConsumerRole(() => renderRoutes(routes)),
);

export default ConsumerMasterRoute;
